import React from 'react';
import WhatsappLogo from '../../../assets/whatsapp-white-small.svg';
import DiscordLogo from '../../../assets/discord-white-small.svg';
import LineLogo from '../../../assets/line-white-small.svg';
import TelegramLogo from '../../../assets/telegram-white-small.svg';
import { Link } from 'react-router-dom';

export const handleClickToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};
const Footer: React.FC = () => {

    return (
        <footer className='footer'>
            <div className='footer_content'>
                <div className='pages_links'>
                    <Link to='/privacy_policy' onClick={handleClickToTop}>Privacy Policy</Link>
                    <Link to='/legal_information' onClick={handleClickToTop}>Legal Information</Link>
                </div>
                <div className='social_links'>
                    <img src={WhatsappLogo} alt='whatsapp logo' onClick={() => window.open('https://whatsapp.magicbot.fr/', '_blank')} />
                    <img src={DiscordLogo} alt='Discord logo' onClick={() => window.open('https://discord.magicbot.fr/', '_blank')} />
                    <img src={LineLogo} alt='Line logo' onClick={() => window.open('https://line.magicbot.fr/', '_blank')} />
                    <img src={TelegramLogo} alt='Telegram logo' onClick={() => window.open('https://telegram.magicbot.fr/', '_blank')} />
                </div>
            </div>
            <div className='rights'>
                <p>© 2024 MagicBot.</p>
                <p>All rights reserved.</p>
            </div>

        </footer>
    );
}

export default Footer;
